import { create } from "zustand";
import axios from "axios";

const useEmployeeLeaveHistoryStore = create((set) => ({
  leaveHistory: [],
  loading: false,
  error: null,

  fetchLeaveHistory: async (id, accessToken, from = null, to = null) => {
    try {
      set({ loading: true, error: null });

      let url = `${process.env.REACT_APP_BASE_URL}/employees/${id}/leaves`;

      if (from && to) {
        url += `?from=${from}&to=${to}`;
      }

      const response = await axios.get(url, {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      });

      const dataObject = response.data?.data || {};
      const dataArray = Object.keys(dataObject).map(
        (key) => dataObject[key]
      );

      set({
        leaveHistory: dataArray,
        loading: false,
      });
    } catch (error) {
      console.error(error);

      set({
        leaveHistory: [],
        loading: false,
        error,
      });
    }
  },

  resetLeaveHistory: () =>
    set({
      leaveHistory: [],
      error: null,
    }),
}));

export default useEmployeeLeaveHistoryStore;